import script from "./IframeBackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeBackButton.vue?vue&type=script&setup=true&lang=js"

import "./IframeBackButton.vue?vue&type=style&index=0&id=8de59f98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8de59f98"]])

export default __exports__